
import React, { useEffect, useState } from "react";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { Box, Button, makeStyles } from "@material-ui/core";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { clinicImpersonated } from "../../util/functions";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import instance from "../../util/axios";
import Cookie from "js-cookie";
import { CircularProgress } from '@material-ui/core';

const useStyles = makeStyles(() => {
  return {
    root: {
      backgroundColor: "rgb(246, 246, 247)",
    },
    boxWrapper: {
      display: "grid",
      gap: 25,
      backgroundColor: "rgb(246, 246, 247)",
      height: "fit-content",
      padding: 20,
    },
    statusesWrapper: {
      display: "grid",
      width: "10%",
      gap: 10,
    },
    loadingBox: {
      margin: "8% auto",
      textAlign: "center",
      padding: 30,
    },
    loading: {
      textAlign: "center",
      margin: "0 auto",
      color: "#ff2c46",
    },
    cardStyle: {
      display: "grid",
      width: "100%",
      flexWrap: "wrap",
      ["@media only screen and (max-width: 1170px) "]: {
        gridTemplateColumns: "1fr",
      },
    },
    gridtemplate2Column: {
      gridTemplateColumns: "1fr 1fr",
    },
    gridtemplate1Column: {
      gridTemplateColumns: "1fr",
    },
    btnWrapper: {
      backgroundColor: "#fff",
      borderRadius: "3px",
      height: 0,
      boxShadow: "inset 0 -1px 0 0 #DFE3E8",
      position: "absolute",
      top: "100%",
      width: "100%",
      overflow: "hidden",
      transition: "height 0.3s ease-out",
      zIndex: 100,
    },
    btnWrapperPositionRight: {
      right: "0.5%",
    },
    btnWrapperPositionLeft: {
      left: "0.5%",
    },
    padding: {
      padding: "1rem",
    },
    backbtn: {
      color: "#637381",
      fontSize: "16px !important",
      letterSpacing: 0,
      lineHeight: "20px",
      "&:hover": {
        backgroundColor: "#F6F6F7",
      },
    },
    slideBtn: {
      width: "100%",
      height: "45px",
      justifyContent: "flex-start",
      color: "#212B36",
      fontSize: "14px !important",
      letterSpacing: 0,
      lineHeight: "20px",
      padding: "0 0.6rem",
      textAlign: "left",
      boxShadow: "inset 0 -1px 0 0 #DFE3E8",
      "&:hover": {
        backgroundColor: "#FFF",
      },
    },
    slideanimation: {
      height: "auto",
      boxShadow:
        "0 0 0 1px rgba(63,63,68,0.05), 0 1px 3px 0 rgba(63,63,68,0.15)",
    },
    uploadBtn: {
        height: "35px",
        width: "fit-content",
        backgroundColor: "#FF2C46",
        color: "#fff",
        fontSize: "14px",
        padding: "0 25px",
        "&:hover": {
          backgroundColor: "#FF2C46",
      },
    },
    topBar: {
      display: "flex",
      justifyContent: "space-between",
      margin: "1rem 0",
    },
  };
});
export default function TopBar({ userId }) {
  const classes = useStyles();
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const [isVisible, setVisible] = useState(false);
  const [medicalConsentVisible, setMedicalConsentVisible] = useState(false);
  const [showIcon, setShowIcon] = useState(false);
  const clinic_id = Cookie.get("clinic_id");
  const {id} = useParams();
  const [loading, setLoading] = useState(false);
  const [fetchUrl, setFetchUrl] = useState({
    consentFormUrl: "",
    patientHistoryEnUrl: "",
    patientHistoryArUrl: ""
  });
  useEffect(() => {
    async function fetchData() {
      try {
        setLoading(true);

        const response = await instance.get(`/admin/v1/provider/user-medical-consent-history/${id}`, {
          params: { clinic_id },
          headers: {
            Authorization: "Bearer " + Cookie.get("access_token_clinic"),
          },
        });
        const data = response.data;
        setShowIcon(data.exists);
        setFetchUrl({
          consentFormUrl: data?.consent_form_pdf_url,
          patientHistoryEnUrl: data?.patient_history_en_url || "",
          patientHistoryArUrl: data?.patient_history_ar_url || ""
        });
      } catch (error) {      
        console.error(error);
      }finally {
      setLoading(false);
      }
    }

    fetchData();
  }, [clinic_id, id]);


  return (
    <Box className={classes.topBar}>
      <Button
        onClick={() => navigate("/dashboard")}
        className={classes.backbtn}
        startIcon={
          i18n.language === "ar" ? (
            <ArrowForwardIosIcon
              style={{
                marginLeft: "1rem",
                fontSize: "15px",
                fontWeight: "bold",
              }}
            />
          ) : (
            <ArrowBackIosIcon
              style={{ fontSize: "15px", fontWeight: "bold" }}
            />
          )
        }
      >
        {t("back")}
      </Button>
      <Box style={{display:"flex",gap: "8px",flexWrap: "wrap", }}>
      <Box style={{ position: "relative" }}>
      <Box
        className={`${ 
          i18n.language === "ar"
            ? classes.btnWrapperPositionLeft
            : classes.btnWrapperPositionRight
        } ${classes.btnWrapper} ${medicalConsentVisible ? classes.slideanimation : ""}`}
      >
      {loading ? (
        <Button className={classes.slideBtn} disabled style={{ height: "35px" }}>
          <CircularProgress size={20} style={{  color:" #fd2d42", marginRight: 8 }} />
          {t("Loading")}
        </Button>
      ) : (
        <>
          <Button
            className={classes.slideBtn}
            style={{ height: "35px" }}
            disabled
          >
            {t("Select-an-action")}
          </Button>

          <Button
            onClick={() => window.open(fetchUrl.consentFormUrl, "_blank")}
            className={classes.slideBtn}
          >
            {t("Download-Consent-Form")}
          </Button>
          {fetchUrl.patientHistoryEnUrl && (
            <Button
              onClick={() => window.open(fetchUrl.patientHistoryEnUrl, "_blank")}
              className={classes.slideBtn}
            >
              {t("Patient-History-en")}
            </Button>
          )}
          {fetchUrl.patientHistoryArUrl && (
            <Button
              onClick={() => window.open(fetchUrl.patientHistoryArUrl, "_blank")}
              className={classes.slideBtn}
            >
              {t("Patient-History-ar")}
            </Button>
          )}
          <Button
            className={classes.slideBtn}
            onClick={() => navigate(`/dashboard/users/${userId}/medicalConsent`)}
          >
            {showIcon && <CheckCircleIcon style={{  color:" #fd2d42", marginRight: 4 }} />}
            {t("Upload/View-Consent-form")}
          </Button>
        </>
      )}
      </Box>
        <Button
          disabled={clinicImpersonated()}
          onClick={() => setMedicalConsentVisible((prev) => !prev)}
          className={classes.uploadBtn}
        >
          <ArrowDropDownIcon /> {t("Medical-Consent")}
        </Button>
      </Box>
      <Box style={{ position: "relative" }}>
        <Box
          className={`${
            i18n.language === "ar"
              ? classes.btnWrapperPositionLeft
              : classes.btnWrapperPositionRight
          } ${classes.btnWrapper} ${isVisible ? classes.slideanimation : ""}`}
        >
          <Button
            className={`${classes.slideBtn}`}
            style={{ height: "35px" }}
            disabled
          >
            {t("Select-an-action")}
          </Button>
          <Button
            onClick={() => navigate(`/dashboard/users/${userId}/addPhotoId`)}
            className={`${classes.slideBtn}`}
          >
            {t("Photo-ID")}
          </Button>
          <Button
            onClick={() =>
              navigate(`/dashboard/users/${userId}/new-file/Other`)
            }
            className={`${classes.slideBtn}`}
          >
            {t("Other-Files")}
          </Button>
          <Button
            onClick={() => navigate(`/dashboard/users/${userId}/memberShipId`)}
            className={`${classes.slideBtn}`}
          >
            {t("membership-id")}
          </Button>
        </Box>
        <Button
          disabled={clinicImpersonated()}
          onClick={() => setVisible((prev) => !prev)}
          className={classes.uploadBtn}
        >
          <ArrowDropDownIcon /> {t("Upload-Files")}
        </Button>
      </Box>
      </Box>


    </Box>
  );
}